import React, { useState } from 'react';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { login } from '../../services/auth';
import api from '../../services/api';
import { URL } from '../../constants/index';
import LogoBranco from '../../assets/LogoBranco.png';
import './styles.css';

const Login = () => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erroLogin, setErroLogin] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onPrimeiroLogin = () => history.push(URL.URLPrimeiroLogin);
  const onRecuperarSenha = () => history.push(URL.URLRecuperarSenha);

  const validarLogin = () => {
    if (!usuario || !senha) {
      tratarErroLogin('Preencha usuário e senha para continuar');
      return false;
    }
    return true;
  };

  const tratarErroLogin = (erro) => {
    setErroLogin(erro);
    setSenha('');
    setLoading(false);
  };

  const tratarSucessoLogin = (data) => {
    login(data);
    history.push(URL.URLDashboardAtual);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErroLogin('');

    if (!validarLogin()) return;

    api.post('/login/token',
      qs.stringify({
        grant_type: 'password',
        username: usuario,
        password: senha
      }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
      .then(res => tratarSucessoLogin(res.data))
      .catch(err => {
        if (err.response && err.response.status === 400) {
          tratarErroLogin(`${err.response.data.error} - ${err.response.data.error_description}`);
        } else {
          tratarErroLogin('Erro ao se comunicar com a API de Login');
        }
      });
  };

  return (
    <div className="login-container">
      <div className="login-visual">
        <div className="visual-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
        <div className="visual-content">
          <img src={LogoBranco} alt="PWI Sistemas" className="login-logo-large" />
          <h1 className="visual-title">VolpeBI</h1>
        </div>
      </div>

      <div className="login-form-section">
        <div className="login-form-wrapper">
          <div className="login-header">
            <h2>Bem-vindo!</h2>
            <p>Informe suas credenciais para acessar o painel</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            {erroLogin && (
              <div className="login-error-alert">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                <span>{erroLogin}</span>
              </div>
            )}

            <div className="login-input-group">
              <label htmlFor="usuario">Usuário</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <input
                  id="usuario"
                  type="text"
                  placeholder="Seu usuário"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="login-input-group">
              <label htmlFor="senha">Senha</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                <input
                  id="senha"
                  type="password"
                  placeholder="Sua senha secreta"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? (
                <ReactLoading type="bubbles" color="#ffffff" height={24} width={40} className="loading-indicator" />
              ) : 'Entrar na Plataforma'}
            </button>
          </form>

          <div className="login-actions">
            <button type="button" className="btn-secondary" onClick={onPrimeiroLogin}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
              Primeiro Acesso
            </button>
            <button type="button" className="btn-text" onClick={onRecuperarSenha}>
              Recuperar senha
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
